import { createRoot } from 'react-dom/client';
import { IntlProvider } from 'react-intl';

import { ThemeProvider, ToastPortal } from '@mollie/ui-react';
import '@mollie/ui-assets/css/index.css';

import { App } from './App';

const root = createRoot(document.querySelector('#root') as HTMLElement);

root.render(
  <IntlProvider locale="en-US">
    <ThemeProvider theme="light">
      <App />
      <ToastPortal maxCount={1} />
    </ThemeProvider>
  </IntlProvider>,
);
